import React from "react";
import { IoClose } from "react-icons/io5";

const VerificationInstructionsPopup = ({ onClose }) => {
  return (
    <div className="verification-instructions-modal">
      <div className="verification-instructions-content">
        <div className="verification-instructions-header">
          <h3>Student Verification Instructions</h3>
          <button className="close-button" onClick={onClose}>
            <IoClose size={20} />
          </button>
        </div>
        <div className="verification-instructions-body">
          <p>
            Before accepting students into the exam, please verify each student
            by following these guidelines:
          </p>
          <ul>
            <li>Ensure each student is clearly visible in their camera view</li>
            <li>
              <strong>Verify that each student is holding their ID card</strong>{" "}
              clearly visible to the camera
            </li>
            <li>Confirm that the student's face matches their ID photo</li>
            <li>
              Make sure the student's environment is appropriate for taking an
              exam (good lighting, clear desk, etc.)
            </li>
            <li>Only accept students who meet all verification requirements</li>
          </ul>
          <p>
            Students who fail to meet these requirements should be rejected and
            instructed to fix the issues before trying again.
          </p>
        </div>
        <div className="verification-instructions-footer">
          <button className="verify-button" onClick={onClose}>
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerificationInstructionsPopup;
